// Mock data for MatrixLaunch crypto launchpad

export const stats = {
  totalRaised: "47,500,000",
  activeInvestors: "128,450",
  projectsLaunched: "89"
};

export const featuredProjects = [
  {
    id: 1,
    name: "QuantumSwap",
    symbol: "QSW",
    description: "Next-gen DEX with AI-powered liquidity pools",
    logo: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=400",
    status: "live",
    softCap: "500,000",
    hardCap: "2,000,000",
    raised: "1,250,000",
    progress: 62.5,
    startDate: "2025-01-15",
    endDate: "2025-02-15",
    tokenPrice: "0.05",
    network: "ETH",
    participants: 3420
  },
  {
    id: 2,
    name: "MetaVault",
    symbol: "MVT",
    description: "Decentralized asset management protocol",
    logo: "https://images.unsplash.com/photo-1622630998477-20aa696ecb05?w=400",
    status: "upcoming",
    softCap: "800,000",
    hardCap: "3,500,000",
    raised: "0",
    progress: 0,
    startDate: "2025-02-20",
    endDate: "2025-03-20",
    tokenPrice: "0.12",
    network: "BSC",
    participants: 0
  },
  {
    id: 3,
    name: "ChainGuard",
    symbol: "CGD",
    description: "Advanced blockchain security infrastructure",
    logo: "https://images.unsplash.com/photo-1644361566696-3d442b5b482a?w=400",
    status: "completed",
    softCap: "1,000,000",
    hardCap: "4,000,000",
    raised: "4,000,000",
    progress: 100,
    startDate: "2024-12-01",
    endDate: "2025-01-01",
    tokenPrice: "0.08",
    network: "ETH",
    participants: 8750
  },
  {
    id: 4,
    name: "SolarPay",
    symbol: "SPAY",
    description: "Green energy crypto payment gateway",
    logo: "https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=400",
    status: "live",
    softCap: "600,000",
    hardCap: "2,500,000",
    raised: "890,000",
    progress: 35.6,
    startDate: "2025-01-10",
    endDate: "2025-02-10",
    tokenPrice: "0.03",
    network: "Polygon",
    participants: 2150
  },
  {
    id: 5,
    name: "NeuralChain",
    symbol: "NRC",
    description: "AI-powered blockchain analytics platform",
    logo: "https://images.unsplash.com/photo-1635322966219-b75ed372eb01?w=400",
    status: "upcoming",
    softCap: "1,200,000",
    hardCap: "5,000,000",
    raised: "0",
    progress: 0,
    startDate: "2025-03-01",
    endDate: "2025-04-01",
    tokenPrice: "0.15",
    network: "ETH",
    participants: 0
  },
  {
    id: 6,
    name: "TokenVerse",
    symbol: "TKVS",
    description: "Metaverse token economy infrastructure",
    logo: "https://images.unsplash.com/photo-1640826514546-7d2d93f0f2f7?w=400",
    status: "completed",
    softCap: "750,000",
    hardCap: "3,000,000",
    raised: "3,000,000",
    progress: 100,
    startDate: "2024-11-15",
    endDate: "2024-12-15",
    tokenPrice: "0.06",
    network: "BSC",
    participants: 6890
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Alex Chen",
    role: "Early Investor",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    text: "MatrixLaunch gave me access to projects I wouldn't have found elsewhere. 300% ROI in 6 months!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    role: "Network Builder",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
    text: "The referral program is incredible. I'm earning passive income while helping others invest in quality projects.",
    rating: 5
  },
  {
    id: 3,
    name: "Michael Rodriguez",
    role: "Project Founder",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
    text: "Launched our token through MatrixLaunch. The community is engaged, and the platform is professional.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is MatrixLaunch?",
    answer: "MatrixLaunch is a decentralized launchpad platform that connects crypto investors with carefully vetted early-stage blockchain projects. We combine investment opportunities with a multi-level referral system."
  },
  {
    id: 2,
    question: "How do I participate in a token launch?",
    answer: "Connect your Web3 wallet (MetaMask, Trust Wallet, etc.), complete KYC verification, browse active projects, and invest directly through our platform. All transactions are secured by smart contracts."
  },
  {
    id: 3,
    question: "What is the MLM/Referral program?",
    answer: "Our multi-level referral system rewards you for building a network. Earn commissions on direct referrals and their network activity. Create passive income while growing the community."
  },
  {
    id: 4,
    question: "Which blockchain networks do you support?",
    answer: "We support multiple networks including Ethereum (ETH), Binance Smart Chain (BSC), Polygon (MATIC), and more. Each project specifies its launch network."
  },
  {
    id: 5,
    question: "How are projects vetted?",
    answer: "Every project undergoes rigorous due diligence including team verification, smart contract audits, tokenomics review, and business model analysis. Only legitimate projects are listed."
  },
  {
    id: 6,
    question: "What are the fees?",
    answer: "Platform fees are minimal and transparent. 2% on successful investments, with no hidden charges. Referral commissions are paid from our platform revenue, not your investment."
  }
];

export const mlmStructure = [
  {
    level: 1,
    commission: "10%",
    description: "Direct referrals"
  },
  {
    level: 2,
    commission: "5%",
    description: "Second level network"
  },
  {
    level: 3,
    commission: "3%",
    description: "Third level network"
  },
  {
    level: 4,
    commission: "2%",
    description: "Fourth level network"
  },
  {
    level: 5,
    commission: "1%",
    description: "Fifth level network"
  }
];

export const dashboardData = {
  walletBalance: "15,847.50",
  totalInvested: "25,000.00",
  currentValue: "38,450.00",
  totalEarnings: "13,450.00",
  referralEarnings: "2,890.00",
  rank: "Diamond",
  directReferrals: 23,
  networkSize: 147,
  investments: [
    {
      project: "QuantumSwap",
      amount: "5,000",
      currentValue: "8,250",
      roi: "+65%",
      status: "active"
    },
    {
      project: "ChainGuard",
      amount: "10,000",
      currentValue: "18,500",
      roi: "+85%",
      status: "completed"
    },
    {
      project: "SolarPay",
      amount: "7,500",
      currentValue: "9,200",
      roi: "+23%",
      status: "active"
    },
    {
      project: "TokenVerse",
      amount: "2,500",
      currentValue: "2,500",
      roi: "0%",
      status: "vesting"
    }
  ]
};

export const socialLinks = {
  telegram: "https://t.me/matriclaunch",
  discord: "https://discord.gg/matriclaunch",
  twitter: "https://twitter.com/matriclaunch",
  medium: "https://medium.com/@matriclaunch"
};
